export const Strings = {
  shortId: (id: string) => id.slice(0, 5) + "..." + id.slice(-5),




};

